import { compose } from 'redux';
import { isFunction, property } from 'lodash-es';
import { propFromSelector } from '../utils';
import { ITEM_STATES_TO_DEFINITION_CODES } from '../../constants';

const getRouter = property('router');
const routerProp = propFromSelector(getRouter);

const currentState = routerProp('currentState');
const currentStateProp = propFromSelector(currentState);
export const currentName = currentStateProp('name');

const currentData = currentStateProp('data');
export const currentDataProp = propFromSelector(currentData);
export const currentDataSuccessState = currentDataProp('successState');
const currentDataMoveItem = currentDataProp('moveItem');
export const currentDataMoveItemSingleton = compose(
  property('singleton'),
  currentDataMoveItem
);
export const currentDataMoveItemType = state => {
  let { type } = currentDataMoveItem(state) || {};
  type = isFunction(type) ? type(state) : type;
  return type || ITEM_STATES_TO_DEFINITION_CODES[currentName(state)];
};

const currentParams = routerProp('currentParams');
export const currentParamsProp = propFromSelector(currentParams);
export const currentParamsId = currentParamsProp('id');
export const currentParamsVerified = currentParamsProp('verified');
export const currentParamsInviteToken = currentParamsProp('inviteToken');
export const currentParamsCode = currentParamsProp('code');

const currentAnalytics = currentStateProp('analytics');
export const currentAnalyticsProp = propFromSelector(currentAnalytics);
export const currentAnalyticsPage = currentAnalyticsProp('page');
